import { ParameterInfos } from 'ut-business/parameter';

export const tilingCanvasParameters: Record<string, ParameterInfos> = {
  TilePositionX: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
    },
    imperial: {
      unit: 'in',
      decimals: 2,
    },
    inspectionMode: {
      analysis: {
        isReadOnly: false,
      },
    },
  },
  TilePositionY: {
    sourceUnit: 'm',
    metric: {
      unit: 'mm',
      decimals: 2,
    },
    imperial: {
      unit: 'in',
      decimals: 2,
    },
    inspectionMode: {
      analysis: {
        isReadOnly: false,
      },
    },
  },
};
